import Alpine from 'alpinejs'
import { Chart } from 'chart.js/auto'

window.Chart = Chart
window.Alpine = Alpine


Alpine.store('sidebar', {
  open: false
})

Alpine.store('modal', {
  state: 'hidden'
})

Alpine.data('chartHandler', () => ({
  init() {
    // Initialize chart after a short delay to ensure DOM is ready
    setTimeout(() => {
      window.DISC.init();
    }, 0);
  },

  // Cleanup when component is destroyed
  destroy() {
    if (window.DISC.chart) {
      window.DISC.chart.destroy();
      window.DISC.chart = null;
    }
  }
}))

Alpine.data('visibleNavHighlighter', () => ({
  headings: null,
  visibleHeadingId: null,

  init() {
    this.headings = document.querySelectorAll('[listen-for-intersection-of-titles] h2:not([no-sidebar]), [listen-for-intersection-of-titles] h3:not([no-sidebar]), [listen-for-intersection-of-titles] h4:not([no-sidebar])')
    this.assignHeadingIds()
    this.onScroll()

    // Add scroll event listener
    window.addEventListener('scroll', () => this.onScroll())
  },

  assignHeadingIds() {
    if (!this.headings) return
    this.headings.forEach(heading => {
      if (heading.id) return
      heading.id = heading.textContent.replace(/\s+/g, '-').toLowerCase()
    })
  },

  onScroll() {
    if (!this.headings) return
    let relativeTop = window.innerHeight / 2
    let headingsByDistanceFromTop = {}

    this.headings.forEach(heading => {
      headingsByDistanceFromTop[heading.getBoundingClientRect().top - relativeTop] = heading
    })

    let closestNegativeTop = Math.max(...Object.keys(headingsByDistanceFromTop).filter(top => top < 0))

    if (closestNegativeTop >= 0 || [Infinity, NaN, -Infinity].includes(closestNegativeTop)) {
      this.visibleHeadingId = null
      return
    }

    this.visibleHeadingId = headingsByDistanceFromTop[closestNegativeTop].id
  }
}))


Alpine.start()



function copyReportUrl() {
  var copyText = document.getElementById("publicUrl");
  navigator.clipboard.writeText(copyText.innerText);
  var clipboardCheck = document.getElementById("clipboardCheck");
  clipboardCheck.classList.add('opacity-100');
  setTimeout(()=> {
    clipboardCheck.classList.remove('opacity-100');
  }, 3000);
}